import React from 'react'
import { Badge, Button, Form, Table } from 'react-bootstrap'

function SreTable({ events, sortColumn, sortDirection, onSort, onDelete, hasMore, selectedTimestamps, onToggleSelect, onToggleSelectAll }) {
  const allSelected = events.length > 0 && events.every((e) => selectedTimestamps.has(e.sre_timestamp))

  function sortIndicator(column) {
    if (sortColumn !== column) return null
    return sortDirection === 'asc' ? ' ▲' : ' ▼'
  }

  return (
    <>
      <div className="table-responsive">
        <Table hover size="sm">
          <thead>
            <tr>
              <th>
                <Form.Check
                  type="checkbox"
                  aria-label="Select all events"
                  checked={allSelected}
                  onChange={onToggleSelectAll}
                />
              </th>
              <th
                role="columnheader"
                style={{ cursor: 'pointer' }}
                onClick={() => onSort('sre_timestamp')}
              >
                Timestamp{sortIndicator('sre_timestamp')}
              </th>
              <th
                role="columnheader"
                style={{ cursor: 'pointer' }}
                onClick={() => onSort('success')}
              >
                Status{sortIndicator('success')}
              </th>
              <th>Message</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {events.map((event) => (
              <tr key={event.sre_timestamp}>
                <td>
                  <Form.Check
                    type="checkbox"
                    aria-label={`Select event ${event.sre_timestamp}`}
                    checked={selectedTimestamps.has(event.sre_timestamp)}
                    onChange={() => onToggleSelect(event.sre_timestamp)}
                  />
                </td>
                <td className="text-nowrap">{event.sre_timestamp}</td>
                <td>
                  <Badge bg={event.success ? 'success' : 'danger'}>
                    {event.success ? 'Success' : 'Failure'}
                  </Badge>
                </td>
                <td>{event.message ?? '—'}</td>
                <td>
                  <Button size="sm" variant="outline-danger" onClick={() => onDelete(event)}>
                    Delete
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
      {hasMore && (
        <p className="text-muted small">
          More events exist — narrow the date range to see older results.
        </p>
      )}
    </>
  )
}

export default SreTable
